import { useMemo } from 'preact/hooks'
import Icon from 'snippets/icon/icon'

function ProductStatus({ maxQuantity, isLoading, initProduct, isPreorder = false, isAvailable = false, earliestPODate = '', isPreorderBundle = false, lowStockMessageOverride = null, isPlpQuickAdd = false }) {
  const lowStockThreshold = window.productState.lowStockThreshold
  const lowStockMessage = window.productState.lowStockMessage
  let lowStockOverride
  if (isPlpQuickAdd === true) {
    lowStockOverride = lowStockMessageOverride
  } else {
    lowStockOverride = window.productState.lowStockMessageOverride
  }
  const outOfStockMessage = window.productState.outOfStockMessage
  const preOrderStatusTextConfig = window.translate.product.preOrderStatusTextConfig || 'Last item to leave warehouse by approximately [date]'
  const preOrderEarlyLabel = window.translate.product.preOrderEarlyLabel || 'Early'
  const preOrderMidLabel = window.translate.product.preOrderMidLabel || 'Mid'
  const preOrderEndLabel = window.translate.product.preOrderEndLabel || 'End of'

  // Remove 0 before the day
  const parsedDate = new Date(earliestPODate)
  parsedDate.setDate(parsedDate.getDate())
  const options = { day: 'numeric', month: 'long', year: 'numeric' }
  earliestPODate = parsedDate.toLocaleDateString('en-AU', options)

  const earliestPODateDay = earliestPODate ? parseInt(earliestPODate.split(' ')[0]) : null
  let earliestPODateLabel = null

  if (earliestPODateDay < 11) {
    earliestPODateLabel = `${preOrderEarlyLabel}`
  } else if (earliestPODateDay >= 11 && earliestPODateDay <= 20) {
    earliestPODateLabel = `${preOrderMidLabel}`
  } else {
    earliestPODateLabel = `${preOrderEndLabel}`
  }

  const earliestPOTime = earliestPODate.replace(earliestPODateDay, '').trim()
  earliestPODateLabel = earliestPODateLabel ? `${earliestPODateLabel} ${earliestPOTime}` : earliestPODate

  const getContent = (quantity) => {
    if (isPreorder) {
      return (
        <div className="product-atc-preorder mt-6 flex flex-row items-center gap-3">
          <Icon viewBox="0 0 24 24" name="icon-clock" className="h-6 w-6 min-w-6 text-grey-500" />
          <p className="text-sm text-grey-1000">
            {translate.product.preOrder}{' '}
            {translate.product.preOrderStatus && <span className="text-sm text-grey-500">- {translate.product.preOrderStatus}</span>}{' '}
            {earliestPODate && isPreorderBundle ? <span> — {preOrderStatusTextConfig.replace('[date]', earliestPODateLabel)}</span> : <span> — Leaves warehouse by approximately {earliestPODateLabel}</span>}
          </p>
        </div>
      )
    } else {
      if (isAvailable && quantity > 0 && quantity <= lowStockThreshold) {
        return (
          <div className="mt-6 flex flex-row items-center gap-3">
            <Icon viewBox="0 0 10 10" name="icon-check" className="m-[3px] h-6 w-6 min-w-6 rounded-full border-2 border-warning-content p-1 text-warning-content" />
            <p className="text-grey-1000">
              Only {quantity} left {maxQuantity > 0 && <span className="text-grey-500">- {lowStockOverride !== null ? lowStockOverride : lowStockMessage}</span>}
            </p>
          </div>
        )
      } else if (isAvailable && quantity > lowStockThreshold) {
        return (
          <p className="mt-6 text-grey-1000">
            {translate.product.inStock}
            <span className="text-grey-500"> - {lowStockOverride !== null ? lowStockOverride : lowStockMessage}</span>
          </p>
        )
      } else {
        return (
          <div className="mt-6 flex flex-row items-center gap-3">
            <Icon viewBox="0 0 24 24" name="icon-close" className="h-6 w-6 min-w-6 text-grey-500" />
            <p className="text-grey-1000">
              <span>{translate.product.outStock}</span>
              {outOfStockMessage && <span className="text-grey-500"> - {outOfStockMessage}</span>}
            </p>
          </div>
        )
      }
    }
  }

  const content = useMemo(() => getContent(maxQuantity), [maxQuantity])

  return !isLoading ? (
    <div className="text-sm">{content}</div>
  ) : (
    <div className="relative animate-pulse">
      <div class="mt-4 h-6 w-full bg-grey-200"></div>
    </div>
  )
}

export default ProductStatus
